import {isMeaningful} from "@/utils/common";
import {adStore} from "@/views/modules/ad/common/store";
import {AdTypeEnum} from "@/views/modules/ad/common/enum";
import {subDays} from 'date-fns'
import {getKeywordsInterpret} from "@/api/ad";
import {mapGetters} from "vuex";

export const tableNameMixin = {
  props: {
    tableName: {
      type: String,
      required: true
    },
  },
};

export const inAdManagerMixin = {
  props: {
    managerType: {
      default: 'adManager',
      validator: function (value) {
        return ['adManager', 'adCampaignManager', 'adGroupManager'].indexOf(value) !== -1
      }
    }
  },
  computed: {
    inAdManager() {
      return this.managerType === 'adManager';
    },
    inAdCampaignManager() {
      return this.managerType === 'adCampaignManager';
    },
    inAdGroupManager() {
      return this.managerType === 'adGroupManager';
    },
  },
};

export const resizeMixin = {
  props: {
    resize: {
      default: null
    }
  },
  // watch: {
  //   resize: {
  //     handler() {
  //       this.$nextTick(() => {
  //         if (this.$refs.gjTable) {
  //           this.tableData = [...this.tableData];
  //         }
  //       });
  //     }
  //   }
  // }
};

export const tabResizeMixin = {
  methods: {
    tabClick(component) {
      this.$nextTick(() => {
        this.$nextTick(() => {
          if (component.$children[0].tableData) {
            component.$children[0].tableData = [...component.$children[0].tableData];
          }
        });
      });
    }
  },
  created() {
    this.activeTab && (this.activeTabMap = this.activeTab)    
  }
};

export const initDateMixin = {
  data: () => {
    return {
      date: null
    }
  },
  props: {
    initDate: {
      default: () => [subDays(new Date(), 6), new Date()]
    }
  },
  created() {
    if (isMeaningful(this.initDate)) {
      this.date = this.initDate;
    }
  }
};

export const inMarketMixin = {
  props: {
    marketId: {
      default: null,
    }
  },
  watch: {
    marketId: {
      immediate: true,
      handler(val, oldVal) {
        if (val !== oldVal
          && isMeaningful(this.marketChange)) {
          this.marketChange(val);
        }
      }
    }
  },
  computed: {
    inMarket() {
      return isMeaningful(this.marketId);
    }
  },
};

export const inPortfolioMixin = {
  props: {
    portfolioId: {
      default: null,
    }
  },
  watch: {
    portfolioId: {
      immediate: true,
      handler(val, oldVal) {
        if (val !== oldVal
          && isMeaningful(this.portfolioChange)) {
          this.portfolioChange(val);
        }
      }
    }
  },
  computed: {
    inPortfolio() {
      return isMeaningful(this.portfolioId);
    }
  },
};

export const inCampaignMixin = {
  props: {
    campaignId: {
      default: null,
    },
    campaign: {
      default: null
    }
  },
  watch: {
    campaignId: {
      immediate: true,
      handler(val) {
        if (isMeaningful(this.campaignChange)) {
          this.campaignChange(val);
        }
      }
    }
  },
  computed: {
    inCampaign() {
      return isMeaningful(this.campaignId);
    }
  },
};

export const inGroupMixin = {
  props: {
    groupId: {
      default: null,
    },
    group: {
      default: null
    }
  },
  watch: {
    groupId: {
      immediate: true,
      handler(val) {
        if (isMeaningful(this.groupChange)) {
          this.groupChange(val);
        }
      }
    }
  },
  computed: {
    inGroup() {
      return isMeaningful(this.groupId);
    }
  },
};

export const adBasePropsMixin = {
  props: {
    campaign: {
      required: false
    },
    group: {
      required: false
    }
  }
};

export const adBaseDataMixin = {
  props: {
    campaign: {
      required: false
    },
    group: {
      required: false
    }
  }
};

export const adStoreMixin = {
  data() {
    return {
      adStore: adStore
    }
  }
};

export const adDefaultSortMixin = {
  data() {
    return {
      defaultSort: {prop: 'cost', order: 'descending'}
    }
  },
  created() {
    this.sort.prop = 'cost';
  },
  computed: {
    querySortEx() {
      return {
        order: this.sort.prop ? `${this.sort.order},descending` : this.sort.order,
        sort: this.sort.prop ? `${this.sort.prop},id` : null
      }
    }
  }
};

// 高级查询
export const adAdvancedFilteringMixin = {
  data() {
    return {
      // 高级筛选枚举
      screenOptons: [
        {text: '曝光量', id: "impressions",value: '',exp: 'gt'},
        {text: '点击量', id: "clicks",value: '',exp: 'gt'},
        {text: 'CTR', id: "ctr",value: '',exp: 'gt', suffix: "%"},
        {text: '广告花费', id: "cost",value: '',exp: 'gt'},
        {text: 'CPC', id: "cpc",value: '',exp: 'gt'},
        {text: '广告订单量', id: "adsOrders",value: '',exp: 'gt'},
        {text: '广告销售额', id: "adsSales",value: '',exp: 'gt'},
        {text: 'CVR', id: "cvr",value: '',exp: 'gt', suffix: "%"},
        {text: 'CPA', id: "cpa",value: '',exp: 'gt'},
        {text: 'ACOS', id: "acos",value: '',exp: 'gt', suffix: "%"},
        {text: 'ROAS', id: "roas",value: '',exp: 'gt', suffix: "%"},
      ]
    }
  },
  methods: {
    // 高级筛选查询
    filterQuery(extendSearch) {
      if (this.filter) {
        this.filter.extendSearch = extendSearch;
      }else {
        this.extendSearch = extendSearch;
      }
      this.$gjNoticeQuery();
    }
  }
};

export const currencySymbolMixin = {
  methods: {
    currencySymbolMixin(data, currencySymbol) {
      if (isMeaningful(data)) {
        return data.map(e => ({
          ...e,
          currencySymbol: currencySymbol || ''
        }))
      }
      return data;
    }
  }
};

export const adTypeRouteMixin = {
  data() {
    return {
      AdTypeEnum: AdTypeEnum
    }
  }
};

//关键词翻译
export const adKeywordTranslation = {
  data(){
    return{
      keywordsOption:{
        EG:'ar',//阿拉伯语
        DE:'de',//德语 1
        ES:'es',//西班牙语 1
        FR:'fr',//法语 1
        IT:'it',//意大利语 1
        JP:'ja',//日语 1
        NL:'nl',//荷兰语 1
        PL:'pl',//波兰语 1
        BR:'pt',//葡萄牙语 1
        SE:'sv',//瑞典语 1
        TR:'tr',//土耳其语 1
        CN:'zh',//汉语
        AE:'en',//英语 1
        SA:'en',//英语 1
        AU:'en',//英语 1
        IN:'en',//英语 1
        SG:'en',//英语 1
        CA:'en',//英语 1
        US:'en',//英语 1
        MX:'es',
        UK:'en'
      }
    }
  },
  computed:{
    ...mapGetters({
      markets: 'authMarkets'
    })
  },
  methods:{
    // 查询关键词翻译
    async getKeywordsInterpret(tableData){
      // 枚举值:
      // ar: 阿拉伯语（EG），de: 德语（DE），en: 英语（AE、EG、SA、AU、IN、SG、CA、US），es: 西班牙语（ES），fr: 法语（FR），it: 意大利语（IT），
      // ja: 日语（JP），nl: 荷兰语（NL），pl: 波兰语（PL），pt: 葡萄牙语（BR），sv: 瑞典语（SE），tr: 土耳其语（TR），zh: 汉语（CN
      let countryCode = this.markets.find(r => r.id === this.marketId).countryCode;
      await getKeywordsInterpret({
        keywords:this._.uniq(tableData.map(r => r.keywordText||r.keyword)),  // 关键词集合
        marketId:this.marketId,  // 站点id
        sourceLanguage:this.keywordsOption[countryCode],  // 关键词原语言
        targetsLanguage:'en' //  关键词翻译语言
      }).then(data => {
        tableData.forEach(e => {
          this.$set(e, "localizeKeywordText", data.find(a => a.keywordText === e.keywordText||a.keywordText === e.keyword)?.localizeKeywordText)
        })
      })
    },
  }
}